export const METODOS_PAGO = [
  { value: "efectivo", label: "Efectivo", transferencia: false },
  { value: "transferencia", label: "Transferencia bancaria", transferencia: true },
  { value: "deposito", label: "Deposito", transferencia: true },
  { value: "tarjeta", label: "Tarjeta", transferencia: false },
  { value: "mensualidad", label: "Mensualidad", transferencia: false },
  { value: "historico", label: "Historico", transferencia: false },
];

const alias = {
  "depósito": "deposito",
  deposito: "deposito",
  "transferencia bancaria": "transferencia",
  transfer: "transferencia",
  transferencia: "transferencia",
  efectivo: "efectivo",
  tarjeta: "tarjeta",
  mensualidad: "mensualidad",
  historico: "historico",
  "histórico": "historico",
};

export const normalizeMetodoPago = (value = "") => {
  const raw = String(value || "").trim();
  const key = raw.toLowerCase();
  const normalized = alias[key] || key || "efectivo";
  const item = METODOS_PAGO.find((metodo) => metodo.value === normalized);
  if (item) return item;
  return {
    value: normalized,
    label: raw || "Efectivo",
    transferencia: normalized.includes("transfer") || normalized.includes("deposit"),
  };
};

export const metodoPagoLabel = (value = "") => {
  if (!String(value || "").trim()) return "";
  return normalizeMetodoPago(value).label;
};

export const metodoPagoPayload = (value = "") => {
  const metodo = normalizeMetodoPago(value);
  return {
    metodo: metodo.value,
    metodoEtiqueta: metodo.label,
    esTransferenciaBancaria: metodo.transferencia,
  };
};
